import clsx from "clsx";

import s from "./styles.module.css";

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
}

export default function Button({ children, className, ...props }: Props) {
  return (
    <a className={clsx(s.button, className)} {...props}>
      {children}
    </a>
  );
}
